<template>
  <div>
     <section class="page-banner" style="background-image: url(/static/img/kaoshijil.png);">
          <div class="container">
              <div class="banner-tip">
                  <h2 class="banner-title">测评记录</h2>
                  <div class="bread-crumbs">
                    Faculty team
                  </div>
              </div>
          </div>
        </section>  
    <section class="course-area course-area4">
   <section>
    <div class="container section-heading">
                  <div class="twotip">
                      <img src="/static/img/apps_fill.png" class="courses-showing-icon"/><span class="courses-showing-text">共有{{ intTotal }}场测评记录</span>
                    </div>
                    <div class="sorting">
                              <p>测评科目:</p>
                              <select name="orderby" class="orderby" v-model="searchSub">
                                  <option value="" selected="selected">所有科目</option>
                                  <option :value="paperSub" v-for="(paperSub, index) in paperSubs" :key="index">{{ paperSub }}</option>
                              </select>
                          </div>
                  <div class="search-box">
                      <input type="search" v-model="searchWords" placeholder="输入关键字...">
                      <button type="submit" @click="toPage(1)"><img src="/static/img/search-line.png" width="21" height="21"/></button>
                  </div>
              </div>
   </section>
    <div class="course-content-wrapper">
        <div class="container">
            <div class="row course-item-wrap">
                <div class="col-lg-12">
                      <div class="tab-content">
                          <div role="tabpanel" class="tab-pane fade show active" id="tab2">
                              <div class="row course-block course-list-block">
                                  <div class="col-lg-12" v-for="(exam, index) in exams" :key="index">
                                      <div class="category-item course-item" v-if="exam.testPaper">
                                           <div class="img">
                                              <div class="score">
                                                  {{ !exam.examAchieveMent ? '0' : exam.examAchieveMent.score }}
                                              </div>
                                              <div class="sums">
                                                总分：{{ exam.testPaper.totalscore }}
                                              </div>
                          
                                            </div>
                                          <div class="course-content">
                                              <p class="course__label">
                                                <a>{{ exam.testPaper.title }}</a>
                                                  <span :class="getExamState(exam).class">{{ getExamState(exam).txt }}</span>
                                                  <!-- <a href="#" class="course__collection-icon" data-toggle="tooltip" data-placement="top" title="Add to Wishlist"><span class="la la-heart-o"></span></a> -->
                                              </p>
                      
                                              <p class="course__author">
                                                <!-- <a style="margin-right:10px">开始测评时间:{{ exam.ctime }}</a>-->  <a>提交时间:{{ !exam.etime ? '无' : exam.etime }}</a> 
                                              </p>
                                              <div class="rating-wrap d-flex">
                                                
                                                  <span class="star-rating-wrap">
                                                      <span class="star__rating">{{ exam.testPaper.examinee.join(",") }} &nbsp;&nbsp;&nbsp;</span>
                                                      <span class="star__count">{{ exam.testPaper.papertype == 'test' ? '模拟测试' : '竞聘测评' }}</span>
                                                  </span>
                                              </div><!-- end rating-wrap -->
                                              <div class="course-meta">
                                                  <ul class="course__list d-flex">
                                                      <li>
                                                          <span class="meta__date">
                                                               正确/错误：{{ !exam.examAchieveMent ? '0' : exam.examAchieveMent.correct }}/{{ !exam.examAchieveMent ? '0' : exam.examAchieveMent.error }}
                                                          </span>
                                                      </li>
                                                      <!-- <li>
                                                          <span class="meta__date">
                                                              得分/总分：{{ !exam.examAchieveMent ? '0' : exam.examAchieveMent.score }}/{{ exam.testPaper.totalscore }}
                                                          </span>
                                                      </li> -->
                                                  </ul>
                                              </div><!-- end course-meta -->
                                              <div class="course-price-wrap">
                                                  <span class="course__price" style="color:#FF0017;">耗时：{{ !exam.ctime || !exam.etime ? '00:00:00' : getTimediff(exam.ctime.replace(/\./g, '/'), exam.etime.replace(/\./g, '/')) }}</span>
                                                  <router-link class="course__btn" v-if="getExamState(exam).class != 'course__label-text_error'" :to="`/achieveview/${exam._id}`">查看试卷</router-link>
                                                  <router-link class="course__btn" style="color:red;border-color:red;" v-else :to="global.isPhone() ? `/exam/${exam.testpaperid}` : `/exampc/${exam.testpaperid}`">继续测评</router-link>
                                              </div><!-- end course-price-wrap -->
                                          </div><!-- end course-content -->
                                      </div><!-- end course-item -->
                                  </div><!-- end col-lg-12 -->
                              </div>
                          </div>
                      </div><!-- end tab-content -->
                    <div class="pagination-wrap">
                        <nav aria-label="Page navigation">
                           <el-pagination
                            background
                            :page-size="6"
                            :hide-on-single-page="intTotal<=6"
                            layout="prev, pager, next"
                            @current-change="toPage"
                            @prev-click="toPage"
                            @next-click="toPage"
                            :total="intTotal">
                        </el-pagination>
                        </nav>
                    </div><!-- end pagination-wrap -->
                </div><!-- end col-lg-8 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-content-wrapper -->
</section><!-- end courses-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        global,
        intTotal:20,
        intCurrent:1,
        exams:[],
        plateId:"",
        paperSubs:[],
        searchWords:"",
        searchSub:""
    };
  },

  components: {},

  computed: {
      
  },
  watch:{
  },
  mounted() {
    console.log("mounted");
    this.$axios.get(`/api/examRecords?page=1&limit=6&sort=-createdAt`).then(res => {
        if(res.data)
        {
            this.exams=res.data.data;
          this.intTotal = res.data.total;
        }
    });
    this.$axios.get("/api/auth/me").then(res => {
      let arrhasCourse = [];
      for (var i = 0; i < res.data.data.needexaminee.length; i++) {
        arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
      }
      this.paperSubs = arrhasCourse;
    });
  },

  methods: {
      toTop(){
        document.body.scrollTop =0;
        document.documentElement.scrollTop = 0;
      },
      setSearchSubs(searchSub){
          this.searchSub = searchSub;
      },
      toPage(intcount){
        if(intcount)this.intCurrent = intcount;
        var searchConditions = "";
        if(this.searchWords)
        {
          searchConditions+="&testpapertitle=$regex:"+this.searchWords;
        }
        if(this.searchSub){
          searchConditions+="&testpaperexaminee="+this.searchSub;
        }
        this.$axios.get(`/api/examRecords?page=${this.intCurrent}&limit=6&sort=-createdAt${searchConditions}`).then((res) => {
            if (res.data) {
                this.intTotal =res.data.total;
              this.exams = res.data.data;
              
                this.toTop();
            }
        });
      },
      getTimediff(starttime, endtime){
            console.log(starttime)
            let start = new Date(starttime);
            let end = new Date(endtime);
            let time = end - start;
            console.log(time);
            //计算出相差天数
            var days=Math.floor(time/(24*3600*1000))
            
            //计算出小时数

            var leave1=time%(24*3600*1000)    //计算天数后剩余的毫秒数
            var hours=Math.floor(leave1/(3600*1000))
            //计算相差分钟数
            var leave2=leave1%(3600*1000)        //计算小时数后剩余的毫秒数
            var minutes=Math.floor(leave2/(60*1000))
            //计算相差秒数
            var leave3=leave2%(60*1000)      //计算分钟数后剩余的毫秒数
            var seconds=Math.round(leave3/1000)
            return `${('00'+hours).slice(-2)}:${('00'+minutes).slice(-2)}:${('00'+seconds).slice(-2)}`
        },
      dateFormat(date, format){
            var o = {
            "M+" : date.getMonth()+1, //month
            "d+" : date.getDate(), //day
            "h+" : date.getHours(), //hour 24
            "H+" : date.getHours(), //hour 24
            "m+" : date.getMinutes(), //minute
            "s+" : date.getSeconds(), //second
            "q+" : Math.floor((date.getMonth()+3)/3), //quarter
            "S" : date.getMilliseconds() //millisecond
            };

            if(/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
            }

            for(var k in o) {
                if(new RegExp("("+ k +")").test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));
                }
            }
            return format;
        },
        getExamTimes(times){
            switch(times)
            {
                case "0":
                    return "不可补考";
                case "1":
                    return "可补考一次";
                case "2":
                    return "不限次数"
            }
        },
         NewDate(str){ 
            if(!str){
                return 0;
            }
            let arr=str.split(" ");
            let d=arr[0].split("-");
            let t=arr[1].split(":");
            var date = new Date();
            date.setUTCFullYear(d[0], d[1] - 1, d[2]);
            date.setUTCHours(t[0], t[1], t[2], 0);
            return date;
        },
        getExamState(exam){
            var objrecord ={};
            switch(exam.state) {
                case "complete":
                    if(exam.examAchieveMent)
                    {
                        objrecord.txt = "完成";
                        objrecord.class = "course__label-text";
                    }else{
                        objrecord.txt = "待批改";
                        objrecord.class = "course__label-text_warning"
                    }
                    break;
                case "fail":
                    objrecord.txt = "未提交";
                    objrecord.class = "course__label-text_failed"
                    break;
                case "edit":
                    objrecord.txt = "正在进行";
                    objrecord.class = "course__label-text_error"
                    break;
                default:
                    objrecord.txt = "未提交";
                    objrecord.class = "course__label-text_failed"
                    break;
            }
            return objrecord;
        },
  }
}

</script>

<style scoped>
/deep/ .el-input__inner{
	height: 61px;
    line-height: 61px;
    width:368.8px;
    margin-top:15px;
    font-size: 16px;
}
/deep/ .el-input__suffix{
     margin-top:15px;
     height: 61px;
   
}
/deep/ .el-select .el-input .el-select__caret{
  color: #4282CAFF;
    font-size: 23px;
    font-weight: 600;
}
.el-icon-search{
        line-height: 61px;
    font-size: 21px;
    margin-right: 10px;
}
/deep/ .el-radio{
    margin-right: 41px;
    margin-left: 27px;
}
/deep/ .el-radio__label{
    font-size:16px;
    /* font-weight: 600; */
}
/deep/ .el-radio__inner{
        border: 2px solid #4485CCFF;
}


.course-content{
  width: 980px;
  height: 301px;
  background: transparent;
}
.course-item {
width: 1194px;
height: 301px;
background: linear-gradient(184deg, #F4F5F8, #FEFFFF);
border: 2px solid rgba(255,255,255,0.83);
box-shadow: 0px 0px 18px 0px rgba(199,202,206,0.33);
border-radius: 5px;
}
.category-item .img{
  width: 217px;
height: 303px;
background:transparent;
}
.category-item .img .score {
  margin-top: 90px;
}
.course-content{
  padding-left: 38px;
    border: none;
}
.course__label{
  margin-top: 54px;
  height: 37px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 500;
    color:#252525;
    display: flex;
    justify-content: start;
    align-items: center;
}
.course__label span{
  margin-left: 20px;
  display: inline-block;
height: 37px;
background: #F9DBDB;
border-radius: 5px;
font-size: 20px;
font-family: PingFang SC;
font-weight: 500;
color: #F55C57;
line-height: 37px;
padding:0 20px ;

}
.course__price{
margin-left: 0px;
}
.course__label-text{

}
.course__label-text_failed{

}
.course__label-text_error{

}
.course__label-text_warning{

}
.course__title{
    margin-top:0px;
}
.course__title a{
    margin-left: 44px;
}
.star-rating-wrap{
  padding-top: 20px;
  height: 16px;
  line-height: 16px;
  left: 0px;
  color:#E77C3B;
  font-size: 16px;
}
.course-meta li{
        margin-left: 0px;
}
.meta__date{
  padding-top: 30px;
    float: right;
    font-size: 16px;
    color: #2F3D59;
}
.course__price {
  /* padding-top: 10px; */
  font-size: 16px;
}
.course__author{
  padding-top: 20px;
  margin-left: 0;
  color:#717D86;
  font-size: 16px;
  height: 16px;
  line-height: 16px;
}
.course__btn{
    position: absolute;
    top:38%;
    right: 62px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #4462CF;
    border-bottom:2px solid  #4462CF;
}
.course-price-wrap{
    padding-right: 36px;
}
.section-heading{
  display: flex;
  justify-content: space-between;
}
.twotip {
  padding-left:21px ;
  padding-right: 35px;
  height: 66px;
  background: #4462CF;
  box-shadow: 0px 10px 29px 0px rgba(68, 98, 207, 0.39);
  border-radius: 5px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.search-box input{
  border: 0;
  padding-left:19px;
  padding-right: 12px;;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  width: 235px;
  height: 66px;
  background: #F5F7FF;
}
.search-box input::placeholder{
  color: #B7B7B7;
}
.search-box input[type="search"] {
  height: 66px;
}
.search-box button {
  background: #F5F7FF;
  border: 0;
  height: 66px;
  line-height: 66px;
}
.search-box img{
  margin-top: 0px;
  margin-left: 0px;
}
.search-box button{
  padding: 0 20px;
}
.sorting {
  margin-left: 270px;
  position: relative;
  display: flex;
  min-width: 320px;
  background: #F5F7FF;
  border-radius: 5px;
  height: 66px;
  padding-left: 22px;
}

.sorting p {
  font-size: 20px;
  color: #000000;
  line-height: 66px;
  font-weight: 600;
  margin: 0;
}

.sorting select {
  width: 145px;
  height: 100%;
  line-height: 66px;
  outline: none;
  margin: 0;
  border: 0;
  padding: 0 10px;
  color: #BFBEC0;
  font-size: 20px;
  font-weight: 400;
  -webkit-user-select: none;
  user-select: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
}

.sorting:after {
  content: "\33";
  font-family: 'ElegantIcons';
  display: inline-block;
  font-size: 20px;
  line-height: 66px;
  color: #000000;
  position: absolute;
  font-weight: 600;
  right: 18px;
  top: 0;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
/* two search */
/* fenyeqi s */
.pagination-wrap>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
  width: 25px;
  min-width: 25px;
  height: 25px;
  background: #4462CF;
  border-radius: 50%;
  line-height: 25px;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li:not(.active):hover {
  color: #4462CF;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li {
  width: 25px;
  min-width: 25px;
  height: 25px;
  background: #EEEEEF;
  border-radius: 50%;
  line-height: 25px;
}

.pagination-wrap>>>.el-pagination.is-background .btn-prev {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 1px solid #4462CF;
  border-radius: 50%;
  background: #fff;
  color: #4462CF;
}

.pagination-wrap>>>.el-pagination.is-background .btn-next {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 1px solid #4462CF;
  border-radius: 50%;
  background: #fff;
  color: #4462CF;

}

.pagination-wrap>>>.el-pagination .btn-prev .el-icon {
  font-size: 16px;
}

.pagination-wrap>>>.el-pagination .btn-next .el-icon {
  font-size: 16px;
}

.pagination-wrap>>>.el-pagination {
  width: 1200px;
  text-align: right;
  height: 35px;
  padding-top: 4px;
  padding-bottom: 40px;
}

.pagination-wrap>>>.el-pager {
  height: 35px;
}

.pagination-wrap>>>.el-pager li {
  padding: 0;
  font-size: 14px;
  color: #666666;
}
/* fenyeqi e */
.course-block .course-item .course-content .course-price-wrap .course__price{
  margin-left:0;
  padding-left: 21px;
  background-image:url(/static/img/icon_shijainhasohi.png);
  background-repeat: no-repeat;
  background-size: 16px 16px;
  background-position: left center;
}
</style>